export const head = {
    styles: `
<style>
    /* BASIC RESET */
    html,
    body,
    body div,
    span,
    object,
    iframe,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    blockquote,
    pre,
    abbr,
    address,
    cite,
    code,
    del,
    dfn,
    em,
    img,
    ins,
    kbd,
    q,
    samp,
    small,
    strong,
    sub,
    sup,
    var,
    b,
    i,
    dl,
    dt,
    dd,
    ol,
    ul,
    li,
    fieldset,
    form,
    label,
    legend,
    table,
    caption,
    tbody,
    tfoot,
    thead,
    tr,
    th,
    td,
    article,
    aside,
    figure,
    footer,
    header,
    menu,
    nav,
    section,
    time,
    mark,
    audio,
    video,
    details,
    summary {
        margin: 0;
        padding: 0;
        border: 0;
        vertical-align: baseline;
    }

    main,
    article,
    aside,
    figure,
    footer,
    header,
    nav,
    section,
    details,
    summary {
        display: block;
    }

    html {
        box-sizing: border-box;
    }

    body {
        font-family: 'Arial Unicode MS', Arial, Helvetica, sans-serif;
        font-size: 13px;
        line-height: 1.16;
        letter-spacing: 0.4px;
    }

    .template-base {
        display: block;
        max-width: 740px;
        min-height: 100%;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-size: 24px;
        font-weight: normal;
        padding: 4px 0;
    }

    h2 {
        font-size: 22px;
    }

    h3 {
        font-size: 20px;
    }

    h4 {
        font-size: 18px;
    }

    h5 {
        font-size: 16px;
    }

    h6 {
        font-size: 14px;
    }

    blockquote {
        border-left: 4px solid #dddddd;
        padding-left: 15px;
    }

    p {
        padding: 4px 0;
    }

    a {
        color: #25589a;
        text-decoration: none;
    }

    img {
        vertical-align: text-bottom;
    }

    hr {
        display: block;
        height: 1px;
        border: 0;
        border-top: 1px solid #ccc;
        margin: 4px 0;
        padding: 0;
    }

    small {
        font-size: 85%;
    }

    sub,
    sup {
        font-size: 75%;
        line-height: 0;
        position: relative;
    }

    sup {
        top: -4px;
    }

    sub {
        bottom: -2px;
    }

    .clearfix:after {
        content: " ";
        display: block;
        clear: both;
    }

    table {
        border-collapse: collapse;
        width: 100%;
        max-width: 740px !important;
        margin: 1px 0;
        table-layout: fixed;
    }

    td,
    th {
        padding: 2px 4px;
        border: 1px solid #01579B;
        border-left: none;
        border-right: none;
        text-align: left;
        font-weight: normal;
        vertical-align: top;
    }

    th {
        font-weight: bold;
        vertical-align: middle;
    }

    td p,
    th p {
        margin: 0;
        padding: 0;
    }

    tr:first-child td,
    tr:first-child th {
        border-top: none;
    }

    tr:last-child td,
    tr:last-child th {
        border-bottom: none;
    }

    td,
    th {
        border-left: none;
        border-right: 1px solid #01579B;
    }

    td:first-child,
    th:first-child {
        border-left: none;
    }

    td:last-child,
    th:last-child {
        border-right: none;
    }

    ul {
        margin: 0 10px;
        padding: 4px 10px;
    }

    ul li {
        list-style-type: disc;
    }

    ul li ul li {
        list-style-type: circle;
    }

    ul li ul li ul li {
        list-style-type: square;
    }

    ol {
        margin: 0 10px;
        padding: 4px 15px;
    }

    ol li {
        list-style-type: decimal;
    }

    ol li ol li {
        list-style-type: lower-alpha;
    }

    ol li ol li ol li {
        list-style-type: lower-alpha;
    }

    /* ******************
    * Print/PDF section
    ******************* */
    @page {
        size: A4 portrait;
        margin: 20px 27px 50px 27px;
        font-family: 'Arial Unicode MS', Arial, Helvetica, sans-serif;

        @bottom-right {
            content: "[#if templateOriginCode?length gt 0][=templateOriginCode] |[/#if] strana " counter(page) " / " counter(pages);
            border-top: 1px solid #DDDDDD;
            font-size: 10px;
            color: #81ACCE;
            font-family: 'Arial Unicode MS', Arial, Helvetica, sans-serif;
        }

        @bottom-left {
            content: element(footer);
            border-top: 1px solid #DDDDDD;
            font-size: 10px;
        }
    }

    #footer {
        position: running(footer);
        display: block;
        font-family: 'Arial Unicode MS', Arial, Helvetica, sans-serif;
        color: #888888;
        font-size: 10px;
        line-height: 16px;
    }

    #footer a {
        color: #81ACCE;
        text-decoration: none;
    }

    table {
        -fs-table-paginate: paginate;
    }

    tr.iterator-body {
        page-break-inside: avoid;
        -fs-page-break-inside: avoid;
    }

    thead {
        display: table-header-group;
    }
</style>

`,
};
